// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {LegacyWBIcon} from '@wandb/weave/common/components/elements/LegacyWBIcon';
import {clsx} from 'clsx';
import React from 'react';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

import {GLOBAL_COLORS} from '../../util/colors';
import {
  InspectorPropertyLabel,
  InspectorPropertyWrapper,
} from '../Inspector.styles';
// eslint-disable-next-line import/no-cycle -- please fix if you can
import {PropertyEditorComponent} from './property-editors';

const OptionIcon = styled(LegacyWBIcon)`
  &:hover,
  &.active {
    color: ${GLOBAL_COLORS.linkBlue.toString()};
  }
`;

/**
 * Compact way to offer a small list of options.
 * Default is required.
 */
const IconMenuPropertyEditor: PropertyEditorComponent<'icon-menu'> = props => {
  return (
    <InspectorPropertyWrapper>
      <InspectorPropertyLabel>{props.displayName}</InspectorPropertyLabel>
      {props.options.map(option => (
        // eslint-disable-next-line react/jsx-key
        <OptionIcon
          onClick={() => {
            props.save(option.value);
          }}
          className={clsx({
            active: props.values.indexOf(option.value) !== -1,
          })}
          name={option.icon}
        />
      ))}
    </InspectorPropertyWrapper>
  );
};

export default IconMenuPropertyEditor;
